import * as React from "react";
import { GroupLayout as IGroupLayout, RendererProps } from "@jsonforms/core";
import styled from "styled-components";

import { JsonFormsDispatch, useJsonForms, withJsonFormsLayoutProps } from "@jsonforms/react";
import { Paragraph, ElementWrapper } from "../../styles";
import { breakpointL } from "@ingka/variables/design-tokens";
import parse from "html-react-parser";
import { findAndTransformHTMLString } from "../../renderers/utils";
import LayoutHeading from "../LayoutHeading";

type GroupLayoutSchema = IGroupLayout & {
	subText?: string;
	depth?: string;
	headingLevel?: number;
};

export const StyledDiv = styled.div`
	padding: 1.5rem 1.5rem 1.5rem 0;
	width: 75%;

	h2 {
		margin: 0.75rem 0 0.5rem 0;
	}

	.group-layout {
		width: 100%;
	}

	@media (width < ${breakpointL}) {
		width: 100vw;
	}
`;

const GroupLayout: React.FC<RendererProps> = ({ visible, uischema, schema, path, enabled }) => {
	const { label, elements, subText, headingLevel } = uischema as GroupLayoutSchema;
	const { renderers, cells } = useJsonForms();

	if (!visible) return null;

	return (
		<StyledDiv className="group-layout">
			<LayoutHeading label={label} headingLevel={headingLevel} />
			{subText && <Paragraph>{parse(findAndTransformHTMLString(subText))}</Paragraph>}
			<ElementWrapper>
				{elements.map((child, index) => (
					<JsonFormsDispatch
						key={`${path}-${index}`}
						renderers={renderers}
						cells={cells}
						uischema={child}
						schema={schema}
						path={path}
						enabled={enabled}
					/>
				))}
			</ElementWrapper>
		</StyledDiv>
	);
};

export default withJsonFormsLayoutProps(GroupLayout);
